angular.module('dashboard').controller('AppointmentsDashboardCtrl',
    ['$scope', 'MyAppointmentsRepository', 'MyAppointmentsService', 'DashboardService', 'NotificationService', 'toaster', 'aprgettext', 'PatientPortalStorageRepository', 'PatientSettingsService',
        function ($scope, MyAppointmentsRepository, MyAppointmentsService, DashboardService, NotificationService, toaster, gettext, PatientPortalStorageRepository, PatientSettingsService) {

            'use strict';

            $scope.loading = true;
            $scope.appointments = [];
            var activePatientId = PatientPortalStorageRepository.getActivePatient().id;
            $scope.limitTo = 100;

            var featureList = PatientSettingsService.getPatientFeatures();
            $scope.canCheckInFeature = featureList.CheckIn.IsActive;


            function createAppointmentLists(appointments) {
                $scope.appointments = _(appointments)
                    .forEach(function (item) {
                        item.CanReschedule = false;

                        // Can check in 1 hour early to 1 hour late
                        // Appointment Status cannot be Canceled, Discharged or Checked In
                        item.CanCheckIn = false;
                        item.CanCancel = !(MyAppointmentsService.isCheckIn(item.AppointmentStatus.Id) || item.AppointmentStatus.IsCanceledStatus || MyAppointmentsService.isDischarged(item.AppointmentStatus.Id));
                        if (moment(item.StartDateTime).isBetween(moment().subtract(1, 'hours'), moment().add(1, 'hours'))) {
                            if (item.CanCancel)  {
                                item.CanCheckIn = true;
                            }
                        }

                        item.IsAppointmentToday = false;
                        if (MyAppointmentsService.isAppointmentToday(item.StartDateTime)) {
                            item.IsAppointmentToday = true;
                        }

                    });
            }

            $scope.load = function load(tile) {
                $scope.tile = tile;
                loadPage();
            };

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();

                var searchFilter = {
                    StartDate: moment().format('MM/DD/YYYY'),
                    EndDate: '12/31/9999',
                    SortDirection: 'asc',
                    FetchLimit: 250
                };

                MyAppointmentsRepository
                    .getAppointments(activePatientId, searchFilter)
                    .then(function (data) {
                        createAppointmentLists(data);
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }


            $scope.appointmentCheckIn = function appointmentCheckIn(appointment) {
                $scope.loading = true;
                $scope.removeHttpError();

                MyAppointmentsRepository
                    .changeAppointmentStatus(appointment.PatientId, appointment.AppointmentId, 'CD2A0578-0C89-4151-B4E9-66ED9D5B4995')
                    .then(function () {
                        toaster.pop('success', '', gettext('Appointment check in is successful.'));
                        NotificationService.updateNotifications();
                        loadPage();
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred updating the appointment.'));
                    })
                    .finally(function() {
                        $scope.loading = false;
                    });
            };


            $scope.updateCollapseState = function updateCollapseState()
            {
                $scope.tile.IsCollapsed = !$scope.tile.IsCollapsed;
                DashboardService.setPatientDashboardTileState($scope.tile);
            };


            //$scope.appointmentCancel = function appointmentCancel(appointment) {
            //    alert('Cancel appointment not implemented, yet.  ' + appointment);
            //};

        }
    ]
);